<template>
  <v-flex xs12>
    <v-card class="py-4">
      <v-form v-model="valid">
      <v-layout row wrap class="px-2">
        <v-flex xs12 px-3 py-2 v-if="err">
          <v-alert :value="true" type="error" v-html="err"></v-alert>
        </v-flex>
        <v-flex xs12 px-3 py-2 v-if="success">
          <v-alert :value="true" type="success">{{success}}</v-alert>
        </v-flex>
        <v-flex xs12 px-3>
          <v-textarea
            id="instanceId"
            :label="$lang.labels.instanceId"
            readonly
            auto-grow
            rows="1"
            v-model="instance.instanceId"
          />
        </v-flex>
        <v-flex xs12 md6 px-3>
          <v-text-field
            :label="$lang.labels.name"
            readonly
            v-model="instance.name"
          />
        </v-flex>
        <v-flex xs12 md6 px-3>
          <v-text-field
            :label="$lang.labels.status"
            readonly
            v-model="instance.status"
          />
        </v-flex>
        <v-flex xs12 md6 px-3 v-if="instance.currentVersion">
          <v-text-field
            :label="$lang.labels.currentVersion"
            v-model="instance.currentVersion"
            readonly
          />
        </v-flex>
        <v-flex xs12 md6 px-3 v-if="instance.previousVersion">
          <v-text-field
            :label="$lang.labels.previousVersion"
            v-model="instance.previousVersion"
            readonly
          />
        </v-flex>
        <v-flex xs12 px-3>
          <v-text-field
            :label="$lang.labels.macAddress"
            readonly
            v-model="instance.macAddresses"
          />
        </v-flex>
        <v-flex xs12 px-3>
          <v-text-field
            :label="$lang.labels.moonUrl"
            v-model="instance.moonUrl"
            :rules="[(v) => validURL(v) || `${$lang.errors.notValidUrl}`, (v) => checkIsJustHostname(v) || `${$lang.errors.notValidUrl}`]"
          />
        </v-flex>
        <v-flex xs12 md3 px-3>
          <v-checkbox
            :label="$lang.labels.publicKeySun"
            color="primary"
            class="option"
            hide-details
            readonly
            v-model="instance.sunQueuePublicKeyPresent"
          />
        </v-flex>
        <v-flex xs12 md3 px-3>
          <v-checkbox
            :label="$lang.labels.privateKeySun"
            color="primary"
            class="option"
            hide-details
            readonly
            v-model="instance.sunQueuePrivateKeyPresent"
          />
        </v-flex>
        <v-flex xs12 md6 px-3>
          <v-checkbox
            :label="$lang.labels.publicKeyMoon"
            color="primary"
            class="option"
            hide-details
            readonly
            v-model="instance.moonQueuePublicKeyPresent"
          />
        </v-flex>
        <v-flex xs12 md6 px-3>
          <v-text-field
            :label="$lang.labels.created"
            readonly
            v-model="instance.createdOn"
          />
        </v-flex>
        <v-flex xs12 md6 px-3>
          <v-text-field
            :label="$lang.header.contactedOn"
            readonly
            v-model="instance.lastContactOn"
          />
        </v-flex>
      </v-layout>
      </v-form>
      <v-layout rwo wrap justify-space-between align-center class="px-4">
        <v-btn flat class="mx-0" @click="$router.push({ name: 'moonInstances' })">
          <v-icon>keyboard_arrow_left</v-icon>
          {{$lang.actions.close}}
        </v-btn>
        <div class="d-inline-flex">
          <v-btn class="primary mr-0" @click="submit()" :disabled="!valid">
            Update
          </v-btn>
          <v-btn class="primary mr-0" @click="copyKey">
            Copy Instance ID
          </v-btn>
        </div>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    data: () => ({
      valid: false,
      instance: '',
      err: '',
      success: '',
    }),
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 6000);
        }
      },
      success(val) {
        if (val !== '') {
          setTimeout(() => { this.success = ''; }, 6000);
        }
      },
    },
    methods: {
      validURL(str) {
        const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
      },
      checkIsJustHostname(url) {
        const a = document.createElement('a');
        a.href = url;

        if (a.pathname !== '/' && a.pathname !== '/moonbackend') return false;
        if (a.search) return false;
        if (a.hash) return false;
        if (url.substr(url.length - 1) === '/') return false;
        return true;
      },
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm');
      },
      copyKey() {
        try {
          var copyText = document.getElementById('instanceId');
          copyText.select();
          const success = document.execCommand('copy');
        } catch (e) {
          console.log(e);
        }
      },
      submit() {
        this.$http.post(`moon/instance/update/${this.$route.params.id}`, {
          moonUrl: this.instance.moonUrl,
        })
          .then((res) => {
            if (res.body.status === 'Success') {
              this.success = 'Moon Instance updated successfully';
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
    },
    created() {
      this.$http.get(`moon/instance/${this.$route.params.id}`)
        .then((res) => {
          if (res.body.status === 'Success') {
            const instance = res.body.details;
            instance.createdOn = this.formatDate(instance.createdOn);
            instance.lastContactOn = this.formatDate(instance.lastContactOn);
            this.instance = instance;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
    },
  };
</script>

<style lang="scss" scoped>
  .label {
    min-width: 140px;
    display: flex;
    align-content: flex-start;
    justify-content: flex-end;
  }
</style>



// WEBPACK FOOTER //
// MoonInstanceDetails.vue?9c5a9dea